export type DashboardChartKey = 'customer' | 'schedule' | 'sales' | 'balance' | 'visit1' | 'visit2'

export const dashboardYears = Array.from({ length: 11 }, (_, index) => 2016 + index)

export const dashboardMonths = [
  { value: 'total', label: '월 전체' },
  ...Array.from({ length: 12 }, (_, index) => ({ value: String(index + 1), label: `${index + 1}월` })),
]

export const dashboardOfficeOptions = [
  { value: 'total_hq', label: '직영점 전체' },
  { value: 'mock_office_a', label: 'Mock 지점 A' },
  { value: 'mock_office_b', label: 'Mock 지점 B' },
]

// 비식별 화면 검수용 데이터다. 원본 dev의 운영 통계값을 복사하지 않는다.
export const dashboardSeries: Record<Exclude<DashboardChartKey, 'visit1' | 'visit2'>, number[]> = {
  customer: [0, 1, 6, 1, 3, 0, 0, 1, 3, 4, 0, 0],
  schedule: [0, 3, 7, 2, 7, 0, 0, 3, 0, 4, 6, 0],
  sales: [3, 3, 3, 3, 8, 1, 2, 4, 3, 5, 4, 2],
  balance: [0, 7, 9, 8, 8, 0, 0, 0, 0, 0, 1, 3],
}

export const dashboardVisitSeries: Record<'visit1' | 'visit2', Array<{ label: string; value: number }>> = {
  visit1: [
    { label: 'Mock 경로 A', value: 5 },
    { label: 'Mock 경로 B', value: 3 },
    { label: 'Mock 경로 C', value: 2 },
  ],
  visit2: [
    { label: 'Mock 유형 A', value: 4 },
    { label: 'Mock 유형 B', value: 3 },
    { label: 'Mock 유형 C', value: 2 },
    { label: 'Mock 유형 D', value: 1 },
  ],
}

